import type { GatsbyBrowser } from 'gatsby';

import { PageWrapper, SiteWrapper } from 'components';
import 'i18n';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => <SiteWrapper>{element}</SiteWrapper>;

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => (
  <PageWrapper location={props.location}>{element}</PageWrapper>
);
